<template>
<div class="page_map index pageSearch page_item bg">
    <div class="index_top">
        <div class="page-search">
            <van-row type="flex" justify="space-start">
                <van-col :span="1"></van-col>
                <van-col :span="20">
                    <van-cell-group class="search_field">
                        <form @submit.prevent="formSubmit" action="javascript:return true" > 
                            <van-field v-model="search_value" type="search" :placeholder="placeholder" style="color:#ffffff;" @keydown="searchDown($event)" ref="search" clearable autofocus @input="searchInput" >
                                <van-icon slot="right-icon" :name="righticon" @click="search"  />
                            </van-field>
                        </form>
                        <!-- 可优化关联手机键盘搜索按钮 还需再完善 -->
                        <!-- <van-field v-model="search_value" :placeholder="placeholder" type="search" @keyup.13="show" @blur="search" ref="input1">
                            <van-icon slot="right-icon" :name="righticon" />
                        </van-field> -->
                    </van-cell-group>
                </van-col>
                <van-col :span="3" class="search_ac" @click="search">搜索</van-col>
            </van-row>
        </div>
    </div>
    <!-- 分类 -->
    <div class="page">
        <van-tabs v-model="active" swipe-threshold="6" @change="changeTab">
            <van-tab title="全部" :name="0" />
            <van-tab title="匠人" :name="1" />
            <van-tab title="商品" :name="2" />
            <van-tab title="定制" :name="3" />
            <van-tab title="约看" :name="4" />
        </van-tabs>
    </div>
    <!-- 搜索历史 -->
    <div class="search_fenlei" v-if="searchRecord.length>0&&showSearchRecord">
        <div class="search_title_back">
            <div class="search_title">搜索历史</div>
            <div class="search_delete" @click="deleteRecord">清除</div>
        </div>
        
        <ul class="search_list clearfix">
            <li :class="item.status ? 'search_item f-l slh_s active' : 'search_item f-l slh_s'" v-for="(item,index) in searchRecord" :key="index" @click="searchRecordFun(item)">{{item.name}}</li>
        </ul>
    </div>
    <!-- 热门推荐 -->
    <div class="search_fenlei" v-if="recommendRecord.length!=0&&showSearchRecord">
        <div class="search_title">热门推荐</div>
        <ul class="search_list clearfix">
            <li :class="item.status ? 'search_item f-l slh_s active' : 'search_item f-l slh_s'" v-for="(item,index) in recommendRecord" :key="index" @click="searchRecordFun(item)">{{item.title}}</li>
        </ul>
    </div>
    <div class="no_data" v-if="showNoData">
        <img class="no_data_image" :src="publicPath + 'statics/images/search/no_data.png'" alt="" />
		<div class="no_data_title">暂无搜索结果</div>
        <div class="sepline" v-if="showNoRecommend"/>
        <div class="no_data_recommend" v-if="showNoRecommend">
            <div class="no_data_line"/>为您推荐<div class="no_data_line"/>
        </div>
    </div>
    <div class="page_iteminfo" v-if="active==0">
        <div class="search_data_back" v-if="allData.tradlist && allData.tradlist.length>0">
            <div class="search_title">匠人</div>
            <div class="tradesman_back">
                <div class="tradesman" v-for="(item,index) in allData.tradlist" :key="index" @click="goTradesmanDetail(item)">
                    <van-image class="t_thumb" round :src="item.head?item.head:$publicData.logo"/>
                    <div class="t_title">{{item.title}}</div>
                </div>
            </div>
            <div class="search_more" @click="showMore(1)">
                <img :src="publicPath+'/statics/images/search/search.png'" style="width:0.37rem;height:0.37rem"/>
                <div class="search_more_title">查看更多匠人</div>
            </div>
        </div>
        <div class="search_data_back" v-if="allData.goodlist && allData.goodlist.length>0">
            <div class="search_title">商品</div>
            <div class="goods_back">
                <div :class="index%2==0?'item left ':'item right'" v-for="(item,index) in allData.goodlist" :key="index" @click="goShopDetail(item)">
                    <div :class="item.is_blockchain ? 'thumb blockchain' : 'thumb'">
                        <van-image style="width: 4.267rem;height: 4.267rem;" class="vanImage" fit="cover" :show-error="false" :show-loading="false" :src="item.imgUrl ? imageUrl+item.imgUrl : $publicData.intangibleDefault" />
                    </div>
                    <div class="item_xinxi">
                        <div class="title_wrap single">
                            <div class="title_tag">
                                <span class="icon_self" v-if="item.is_self">自营</span>
                                <span class="icon_new" v-if="item.is_new">最新</span>
                            </div>
                            <span v-if="item.is_self && item.is_new" class="title title1"> {{ item.title }}</span>
                            <span v-else-if="item.is_self || item.is_new" class="title title2"> {{ item.title }}</span>
                            <span v-else class="title title3"> {{ item.title }}</span>
                        </div>
                        <!-- <div class="info clearfix">
                            <div class="shop_name f-l slh_s">{{ item.tradesman_name?item.tradesman_name :'' }}</div>
                            <div class="source f-r">{{ item.place }}</div>
                        </div> -->
                        <div class="info">
                            <span class="f-l price">¥{{ item.price }}</span>
                            <span class="f-r shop_name">{{ item.storeName }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search_more" @click="showMore(2)">
                <img :src="publicPath+'/statics/images/search/search.png'" style="width:0.37rem;height:0.37rem"/>
                <div class="search_more_title">查看更多商品</div>
            </div>
        </div>
        <div class="search_data_back" v-if="allData.madelist && allData.madelist.length>0">
            <div class="search_title">定制</div>
            <div class="dingzhi" v-for="(customade,index) in allData.madelist" :key="index">
                <ul class="dingzhi_list clearfix" @click="goDingzhiDetail(customade)">
                    <div class="dingzhi_left">
                        <van-image fit="cover" :src="customade.imgUrl ? imageUrl+customade.imgUrl : $publicData.intangibleDefault" class="dingzhi_image" :show-error="false" :show-loading="false" />
                        <img class="dingzhi_right" :src="publicPath+'/statics/images/zt_dingzhi.png'"/>
                    </div>
                    <div class="dingzhi_content">
                        <div class="title">{{customade.title}}</div>
                        <div class="tip">已定制</div>
                        <van-progress :percentage="customade.percent" :pivot-text="(customade.hadMadeCount)+'件'"  color="linear-gradient(-90deg, #DF3434, #FF5F34)" />
                        <div class="tip" v-if="customade.timeLeft||customade.end_at">{{ customade.timeLeft ? '剩余时长：' : '截止日期：'}}<span class="nums">{{ customade.timeLeft ? customade.timeLeft :customade.end_at }}</span></div>
                    </div>
                </ul>
            </div>
            <div class="search_more" @click="showMore(3)">
                <img :src="publicPath+'/statics/images/search/search.png'" style="width:0.37rem;height:0.37rem"/>
                <div class="search_more_title">查看更多定制</div>
            </div>
        </div>
        <div class="search_data_back" v-if="allData.livelist && allData.livelist.length>0">
            <div class="search_title">约看</div>
            <div class="pro_item clearfix" v-for="item in allData.livelist" :key="item.id" @click="goYuekanDetail(item.id)">
                <div class="pro_item_l f-l">
                    <van-image fit="contain" :src="item.imgUrl?imageUrl+item.imgUrl:$publicData.intangibleDefault" class="yuekan" :show-error="false" :show-loading="false" />
                    <!-- <img :src="item.thumb" alt="" class="tu"> -->
                </div>
                <div class="pro_item_r f-l">
                    <div class="pro_item_r_t">
                        <div class="f-l title">{{item.title}}</div>
                        <div class="f-r price"><span class="tag_cash">¥</span>{{item.price}}</div>
                    </div>
                    <div class="pro_item_r_b">
                        <div class="info clearfix">
                            <div class="info_l f-l">位置：</div>
                            <div class="info_r f-l slh_s">
                                <span v-if="item.provice">{{item.provice}}</span>
                                <span v-if="item.city">{{ '>' + item.city}}</span>
                                <span v-if="item.area">{{'>' + item.area}}</span>
                            </div>
                        </div>
                        <div class="info clearfix">
                            <div class="info_l f-l">类型：</div>
                            <div class="info_r f-l slh_s">{{item.type}}</div>
                        </div>
                        <div class="info clearfix">
                            <div class="info_l f-l">简介：</div>
                            <div class="info_r slh f-l">{{item.desc}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search_more" @click="showMore(4)">
                <img :src="publicPath+'/statics/images/search/search.png'" style="width:0.37rem;height:0.37rem"/>
                <div class="search_more_title">查看更多约看</div>
            </div>
        </div>
        <div class="search_data_back" v-if="allData.itemlist && allData.itemlist.length>0">
            <div class="search_title">地图定位点</div>
            <div class="location clearfix" v-for="(item,index) in allData.itemlist" :key="index">
                <div class="thumb f-l" @click="goItemInfo(item.id)" v-if="item">
					<van-image fit="contain" :show-loading="false" :src="item.thumb ? imageUrl+item.thumb : $publicData.intangibleDefault" :error-icon="$publicData.intangibleDefault" />
                    <!-- <img :src="item.item.thumb ? item.item.thumb : item.item_first_tu ? item.item_first_tu : $publicData.intangibleDefault" alt style="height:100%" /> -->
                </div>
                <div class="info f-l" style="margin-left: 0.2rem;">
                    <div class="title clearfix" @click="goItemInfo(item.id)">
                        <!-- <div class="f-l tag" v-if="item.item.level">{{item.item.level.title}}</div>
                        <span class="f-l txt">{{item.title}}</span> -->
                        <span class="tag" v-if="item.level">「{{item.level}}」</span>
                            <span class="txt">{{item.title}}</span>
                    </div>
                    <div class="juli clearfix" @click="goItemInfo(item.id)">
                        <span class="f-l tag" v-if="item.cate">{{item.cate}}</span>
                        <span class="f-r num" v-if="item.distance>0">距离约 {{(item.distance/1000).toFixed(2)}}千米</span>
                    </div>
                    <div class="adress clearfix" @click="goItemInfo(item.id)">
                        <span class="f-l">地址：</span>
                        <div class="f-l detail">
                            <span v-if="item.place">{{item.place}}</span>
                        </div>
                    </div>
                    <div class="bottom clearfix">
                        <div class="action f-l" @click="goShop(item.tradesman_id)">店铺</div>
                        <div class="action f-l" @click="goSomeWhere(item.lng,item.lat,item.title)">去这里</div>
                    </div>
                </div>
            </div>
            <div class="search_more" @click="showMore(5)">
                <img :src="publicPath+'/statics/images/search/search.png'" style="width:0.37rem;height:0.37rem"/>
                <div class="search_more_title">查看更多地图定位点</div>
            </div>
        </div>
    </div>
    <!-- 渲染 匠人数据 -->
    <div class="page_iteminfo" v-if="active==1">
        <van-list v-model="loading_tradesman" :finished="finished_tradesman" :finished-text="finishedText" @load="getTradesmanData" v-if="tradesmanList&&tradesmanList.length>0">
            <div class="jiangren">
                <div class="con" v-for="(tradesman,index) in tradesmanList" :key="index">
                    <div class="con_info clearfix" @click="goTradesmanDetail(tradesman)">
                        <div class="thumb f-l">
                            <van-image class="" round :src="tradesman.head?imageUrl+tradesman.head:$publicData.logo"/>
                        </div>
                        <div class="f-l con_info_r">
                            <div class="name slh_s">{{ tradesman.title }}</div>
                            <div class="tag slh_s" v-if="tradesman.auth_company">{{ (tradesman.auth_company).length>5 ? (tradesman.auth_company).slice(0,5)+'...' : tradesman.auth_company }}</div>
                        </div>
                    </div>
                    <div :class="tradesman.is_attention==1 ? 'guanzhu': 'guanzhu guanzhu_no'" @click="attentionTadesmanFun(tradesman)">{{ tradesman.is_attention==1?'已关注':'关注' }}</div>
                </div>
            </div>
        </van-list>
    </div>
    <!-- 渲染 商品数据 -->
    <van-list v-model="loading_goods" :finished="finished_goods" :finished-text="finishedText" @load="getGoodsData" v-if="active==2&&goodsList&&goodsList.length>0">
        <div class="datalist page_goods" >
            <ul class="list">
                <li class="item" v-for="goods in goodsList" :key="goods.id" @click="goShopDetail(goods)">
                    <div :class="goods.is_blockchain ? 'thumb blockchain' : 'thumb'">
                        <!-- <img :src="goods.good_thumb ? goods.good_thumb : $publicData.intangibleDefault" alt="" /> -->
                        <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goods.imgUrl ? imageUrl+goods.imgUrl : $publicData.intangibleDefault" />
                    </div>
                    <div class="item_xinxi">
                        <div class="title_wrap single">
                            <div class="title_tag">
                                <span class="icon_self" v-if="goods.is_self">自营</span>
                                <span class="icon_new" v-if="goods.is_new">最新</span>
                            </div>
                            <span v-if="goods.is_self && goods.is_new" class="title title1 slh_s"> {{ goods.title }}</span>
                            <span v-else-if="goods.is_self || goods.is_new" class="title title2 slh_s"> {{ goods.title }}</span>
                            <span v-else class="title title3 slh_s"> {{ goods.title }}</span>
                        </div>
                        <div class="info clearfix">
                            <div class="shop_name f-l slh_s">{{ goods.storeName?goods.storeName :'' }}</div>
                            <div class="source f-r">{{ goods.place }}</div>
                        </div>
                        <div class="info">
                            <span class="f-l price">¥{{ goods.price }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </van-list>
    <!-- 渲染 定制数据 -->
    <van-list v-model="loading_dingzhi" :finished="finished_dingzhi" :finished-text="finishedText" @load="getDingzhiData" v-if="active==3&&dingzhiList&&dingzhiList.length>0">
        <div class="search_data_back" >
            <div class="dingzhi" v-for="(customade,index) in dingzhiList" :key="index">
                <ul class="dingzhi_list clearfix" @click="goDingzhiDetail(customade)">
                    <div class="dingzhi_left">
                        <van-image fit="cover" :src="customade.imgUrl ? imageUrl+customade.imgUrl : $publicData.intangibleDefault" class="dingzhi_image" :show-error="false" :show-loading="false" />
                        <img class="dingzhi_right" :src="publicPath+'/statics/images/zt_dingzhi.png'"/>
                    </div>
                    <div class="dingzhi_content">
                        <div class="title">{{customade.title}}</div>
                        <div class="tip">已定制</div>
                        <van-progress :percentage="customade.percent" :pivot-text="(customade.hadMadeCount)+'件'"  color="linear-gradient(-90deg, #DF3434, #FF5F34)" />
                        <div class="tip" v-if="customade.timeLeft||customade.end_at">{{ customade.timeLeft ? '剩余时长：' : '截止日期：'}}<span class="nums">{{ customade.timeLeft ? customade.timeLeft :customade.end_at }}</span></div>
                    </div>
                </ul>
            </div>
        </div>
    </van-list>
    <!-- 渲染 约看数据 -->
    <div class="page_yuekan page" v-if="active==4">
        <van-list v-model="loading_yuekan" :finished="finished_yuekan" :finished-text="finishedText" @load="getYuekanData" v-if="yuekanList&&yuekanList.length>0">
            <div class="product">
                <div class="pro_item clearfix" v-for="item in yuekanList" :key="item.id" @click="goYuekanDetail(item.id)">
                    <div class="pro_item_l f-l">
                        <van-image fit="contain" :src="imageUrl+item.imgUrl" alt="" class="tu" />
                    </div>
                    <div class="pro_item_r f-l">
                        <div class="pro_item_r_t clearfix">
                            <div class="title f-l slh">{{item.title}}</div>
                            <div class="price f-r"><span class="tag_cash">¥</span>{{item.price}}</div>
                        </div>
                        <div class="pro_item_r_b">
                            <div class="info clearfix">
                                <div class="info_l f-l">位置：</div>
                                <div class="info_r f-l slh_s">
                                    <span v-if="item.provice">{{item.provice}}</span>
                                    <span v-if="item.city">{{ '>' + item.city}}</span>
                                    <span v-if="item.area">{{'>' + item.area}}</span>
                                </div>
                            </div>
                            <div class="info clearfix">
                                <div class="info_l f-l">类型：</div>
                                <div class="info_r f-l slh_s">{{item.type}}</div>
                            </div>
                            <div class="info clearfix">
                                <div class="info_l f-l">简介：</div>
                                <div class="info_r slh f-l">{{item.desc}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
import dingzhi from '../my/tradesman/dingzhi.vue';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
  components: { dingzhi },
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            routeName: this.$route.query.routeName,
            active: parseInt(this.$route.query.active),
            placeholder: '请输入',
            
            righticon: process.env.BASE_URL + '/statics/images/search_ico.png',
            pages: {
                page: 1,
                size: 10
            },
            search_value: '',
            allData: {
                tradlist: [],
                madelist: [],
                livelist: [],
                goodslist: [],
                itemlist: []
            },
            loading: false,
            finished: false,
            dataList: [],
            // is_shop: null, // 判断是否 从b2c相关页面进来
            loading_goods: false, // 商品
            finished_goods: false, // 商品
            goodsList: [], // 商品数据
            loading_dingzhi: false, // 定制
            finished_dingzhi: false, // 定制
            dingzhiList: [], // 定制数据
            loading_tradesman: false, // 匠人
            finished_tradesman: false, // 匠人
            tradesmanList: [], // 匠人
            finishedText: '', // 加载完成后的提示文案，默认是空，当加载完成时为'没有更多了'
            // unload: false, // 控制请求不同接口时，list组件 load方法自动加载
            mapSearchRecord: [], // 地图搜索历史
            searchRecord: [], // 搜索历史
            recommendRecord: [], // 搜索推荐
            yuekanList: [], // 约看数据
            loading_yuekan: false, // 约看
            finished_yuekan: false, // 约看
            hasItem: false, // 用于判断搜索记录是否有重复的名字
			token: '',
            publicPath: process.env.BASE_URL,
            showSearchRecord: true,
            hasSearchData: false,
            goBack: false,
            showNoData: false,
            showNoRecommend: false
        }
    },
    created() {
        console.log(this.$route.query)
        // 根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '搜索'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
        }
        this.searchRecord = JSON.parse(localStorage.getItem('searchRecord')) ? JSON.parse(localStorage.getItem('searchRecord')) : []
        this.getHotData()
        
	},
    mounted() {
        // console.log('this.$refs:',this.$refs)
        // console.log('this.$refs.search:',this.$refs.search)
        // this.$refs.search.focus()
    },
    beforeDestroy() {
        console.log('beforeDestroy')
    },
    activated: function () {
        console.log('activated')
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            
        } else {
            // 获取列表
            if (this.goBack) { // 从后一页返回不刷新数据，从前一页进入刷新数据
                this.active = parseInt(this.$route.query.active) 
                this.searchRecord = JSON.parse(localStorage.getItem('searchRecord')) ? JSON.parse(localStorage.getItem('searchRecord')) : []
                console.log('activated:searchRecord:',this.searchRecord)
                this.pages = {
                    page: 1,
                    size: 10
                }
                this.search_value= ''
                this.showSearchRecord = true
                this.showNodata = false
                this.showNoRecommend = false
                this.allData= {
                    tradlist: [],
                    madelist: [],
                    livelist: [],
                    goodslist: [],
                    itemlist: []
                }
                this.loading= false
                this.finished= false
                this.dataList=[]
                // is_shop: null, // 判断是否 从b2c相关页面进来
                this.loading_goods= false // 商品
                this.finished_goods= false // 商品
                this.goodsList= [], // 商品数据
                this.loading_dingzhi= false // 定制
                this.finished_dingzhi= false // 定制
                this.dingzhiList= [], // 定制数据
                this.loading_tradesman= false // 匠人
                this.finished_tradesman= false // 匠人
                this.tradesmanList= [] // 匠人
                this.finishedText= '' // 加载完成后的提示文案，默认是空，当加载完成时为'没有更多了'
                // unload: false, // 控制请求不同接口时，list组件 load方法自动加载
                this.recommendRecord= []// 搜索推荐
                this.yuekanList=[] // 约看数据
                this.loading_yuekan= false // 约看
                this.finished_yuekan= false // 约看
                this.getHotData()
            } 
            this.goBack = true
		}
    },
    methods: {
        formSubmit() {
            console.log('formSubmit')
            return false
        },
        searchInput(value) {
            console.log('value:',value)
            console.log('this.search_value:',this.search_value)
            if (this.search_value == null || this.search_value == undefined || this.search_value == '') {
                console.log('value:',111)
                this.showNoData = false;
                this.showNoRecommend = false
                this.showSearchRecord = true
                this.allData= {
                    tradlist: [],
                    madelist: [],
                    livelist: [],
                    goodslist: [],
                    itemlist: []
                }
                this.loading= false
                this.finished= false
                this.dataList=[]
                // is_shop: null, // 判断是否 从b2c相关页面进来
                this.loading_goods= false // 商品
                this.finished_goods= false // 商品
                this.goodsList= [], // 商品数据
                this.loading_dingzhi= false // 定制
                this.finished_dingzhi= false // 定制
                this.dingzhiList= [], // 定制数据
                this.loading_tradesman= false // 匠人
                this.finished_tradesman= false // 匠人
                this.tradesmanList= [] // 匠人
                this.finishedText= '' // 加载完成后的提示文案，默认是空，当加载完成时为'没有更多了'
                // unload: false, // 控制请求不同接口时，list组件 load方法自动加载
                this.recommendRecord= []// 搜索推荐
                this.yuekanList=[] // 约看数据
                this.loading_yuekan= false // 约看
                this.finished_yuekan= false // 约看
                this.getHotData()
            }
        },
        searchDown(event) {
            if (event.code == 'Enter') {
                this.search()
            }
        },
        // 搜索
        search() {
            if (!this.search_value) {
                return
            }
            console.log('search')
            // this.unload = false
            this.pages.page = 1

            if (this.active == 0) {
                // this.allData = {}
                this.getAllData()
            } else if (this.active == 1) {
                this.tradesmanList = []
                this.getTradesmanData()
            } else if (this.active == 2) {
                this.goodsList = []
                this.getGoodsData()
            } else if (this.active == 3) {
                this.dingzhiList = []
                this.getDingzhiData()
            } else if (this.active == 4) {
                this.yuekanList = []
                this.getYuekanData()
            } 
            // 搜索记录
            var hasItem = false
            for (var j in this.searchRecord) {
                this.searchRecord[j].status = 0
                if (this.searchRecord[j].name == this.search_value) {
                    hasItem = true
                    return
                }
            }
            if (!hasItem) {
                this.searchRecord.unshift({
                    name: this.search_value,
                    status: 0
                })
            }
            if (this.searchRecord.length > 10) {
                this.searchRecord.pop()
            }
            localStorage.setItem('searchRecord', JSON.stringify(this.searchRecord));
        },
        deleteRecord() {
            this.searchRecord = []
            localStorage.setItem('searchRecord', JSON.stringify(this.searchRecord));
        },
        // 查询 搜索记录
        searchRecordFun(item) {
            // item 是搜索记录
            var name = item.name
            if (item.name == null || item.name == undefined || item.name == '') {
                name = item.title
            }
            this.search_value = name
            this.pages.page = 1
            // for (var j in this.searchRecord) {
            //     if (this.searchRecord[j].name == name) {
            //         item.status = 1
            //     } else {
            //         this.searchRecord[j].status = 0
            //     }
            // }
            // 匠人
            if (this.active == 0) {
                this.allData = {}
                this.getAllData()
            } else if (this.active == 1) {
                this.tradesmanList = []
                this.getTradesmanData()
            } else if (this.active == 2) { // 商品
                this.goodsList = []
                this.getGoodsData()
            } else if (this.active == 3) {
                this.dingzhiList = []
                this.getDingzhiData()
            } else if (this.active == 4) { // 约看
                this.yuekanList = []
                this.getYuekanData()
            }
        },
        // 取消
        cancel() {
            this.search_value = ''
            this.showSearchRecord = true
            this.allData = {
                tradesman: [],
                tradlist: [],
                madelist: [],
                livelist: [],
                itemlist: [],
                status: 1
            }
            this.dataList = []
            this.goodsList = []
            this.dingzhiList = []
            this.tradesmanList = []
            this.yuekanList = []
        },
        showMore(index) {
            switch (index) {
                case 1:
                case 2:
                case 3:
                case 4: 
                    this.active = index
                    this.search() 
                    break;
                case 5:
                    this.goItemList()
                    break;
                default:
                    break;
            }
        },
        goItemList() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: this.$publicData.clientUrl+"/item/index?search="+this.search_value
                    }
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    data => {}
                );
            } else {
                this.$router.push({
					path: '/item/index',
                    query: {
                        search: this.search_value
                    }
				})
            }
        },
        // 切换tab
        changeTab() {
            console.log('changeTab')
            this.pages.page = 1
            this.finishedText = ''
            console.log('切换')
            if (this.active == 0) {
                this.allData = {
                    tradesman: [],
                    tradlist: [],
                    madelist: [],
                    livelist: [],
                    itemlist: [],
                    status: 1
                }
                this.getAllData()
            } else if (this.active == 1) {
                this.tradesmanList = [];
                if (this.loading_tradesman) {
                    return;
                }
                this.loading_tradesman = true;
                this.finished_tradesman = false;
                this.getTradesmanData()
            } else if (this.active == 2) {
                this.goodsList = []
                if (this.loading_goods) {
                    return;
                }
                this.loading_goods = true;
                this.finished_goods = false;
                this.getGoodsData()
            } else if (this.active == 3) {
                this.dingzhiList = []
                if (this.loading_dingzhi) {
                    return;
                }
                this.loading_dingzhi = true;
                this.finished_dingzhi = false;
                this.getDingzhiData()
            } else if (this.active == 4) {
                this.yuekanList = []
                if (this.loading_yuekan) {
                    return;
                }
                this.loading_yuekan = true;
                this.finished_yuekan = false;
                this.getYuekanData()
            }
            this.getHotData()
        },
        getType() {
            var type = 0
            switch (this.active) {
                case 0: // 全部
                    type = 0
                    break;
                case 1: // 匠人
                    type = 3
                    break;
                case 2: // 商品
                    type = 1
                    break;
                case 3: // 定制
                    type = 5
                    break;
                case 4: // 约看
                    type = 2
                    break;
                default:
                    break;
            }
            return type
        },
        getHotData() {
            console.log('getHotData')
            var params = {
                token: this.token,
                type: this.getType()
            }
            this.$api.index.searchHot(params).then(res => {
                if (res.code == 200) {
                    var typeList = res.result;
                    this.recommendRecord = typeList
                }
            })
        },
        searchEnd(showNodata,showNoRecommend) {
            this.showSearchRecord = false
            this.showNoData = showNodata 
            this.showNoRecommend = showNoRecommend
        },
        getAllData() {
            var that = this
            console.log(this.search_value)
            if (this.search_value == null || this.search_value == undefined || this.search_value == '') {
                return
            }
            var params = {
                token: this.token,
                type: this.getType(),
                key: this.search_value,
            }
            this.$api.index.searchData(params).then(res => {
                if (res.code == 200) {
                    var allData = res.result
                    var madelist = allData.madelist
                    for (var i in madelist) {
                        var info = madelist[i]
                        var hadMadeCount = 0
                        var totalCount = info.accept_order_count ? info.accept_order_count : 0
                        var realCount = info.order_count ? info.order_count : 0
					    var falseCount = info.false_data ? info.false_data : 0
                        if (parseInt(realCount) + parseInt(falseCount) <= totalCount) {
                            hadMadeCount = parseInt(realCount) + parseInt(falseCount)
                        } else {
                            hadMadeCount = totalCount
                        }
                        info.hadMadeCount = hadMadeCount
                        var percentage = 0
                        if (totalCount > 0) {
                            percentage = Math.floor((hadMadeCount / totalCount) * 100)
                            if (percentage < 0) {
                                percentage = 0
                            }
                        } else {
                            percentage = 0
                        }
                        info.percent = percentage
                    }
                    allData.madelist = madelist
                    that.allData = allData
                    that.searchEnd(res.result.status<=0,true)
                }
            })
            console.log('this.allData:',this.allData)
        },
        // 获取商品数据
        getGoodsData() {
            var that = this
            if (this.active != 2) {
                this.loading_goods = false
                this.finished_goods = true
                return
            }
            if (!this.search_value) {
                this.loading_goods = false
                this.finished_goods = true
                return
            }
            console.log('加载商品')
            var params = {
                token: this.token,
                key: this.search_value,
                type: 1,
                page: this.pages.page,
				size: this.pages.size,
				
			};
            this.$api.index.searchData(params).then((res) => {
                if (res.code == 200) {
                    var list = res.result.lists
                    for (var i in list) {
                        this.goodsList.push(list[i])
                    }
                    console.log('this.goodsList:',this.goodsList)
                    if (list.length < this.pages.size || list.length == 0) {
                        // 数据加载完
                        that.finished_goods = true
                        that.finishedText = '没有更多了'
                        // return
                    }
                    that.searchEnd(res.result.status<=0,list&&list.length>0)
                } else {
                    that.finished_goods = true
                    // return
                }
                this.pages.page++
                this.loading_goods = false
            });
        },
        // 获取定制数据
        getDingzhiData() {
            var that = this
            if (this.active != 3) {
                this.loading_dingzhi = false
                this.finished_dingzhi = true
                return
            }
            if (!this.search_value) {
                this.loading_dingzhi = false
                this.finished_dingzhi = true
                return
            }
            console.log('加载定制')
            var params = {
                token: this.token,
                key: this.search_value,
                type: 5,
                page: this.pages.page,
				size: this.pages.size,
				
			};
            this.$api.index.searchData(params).then((res) => {
                if (res.code == 200) {
                    var list = res.result.lists
                    for (var i in list) {
                        var info = list[i]
                        // <van-progress :percentage="((customade.accept_order_count==0&&customade.accept_order_count>0)?0:(customade.order_count<0?0:customade.order_count)+customade.false_data)/customade.accept_order_count*100" :pivot-text="(customade.order_count<0?0:customade.order_count)+'件'"  color="linear-gradient(-90deg, #DF3434, #FF5F34)" />
                        var hadMadeCount = 0
                        var totalCount = info.accept_order_count ? info.accept_order_count : 0
                        var realCount = info.order_count ? info.order_count : 0
					    var falseCount = info.false_data ? info.false_data : 0
                        if (parseInt(realCount) + parseInt(falseCount) <= totalCount) {
                            hadMadeCount = parseInt(realCount) + parseInt(falseCount)
                        } else {
                            hadMadeCount = totalCount
                        }
                        info.hadMadeCount = hadMadeCount
                        var percentage = 0
                        if (totalCount > 0) {
                            percentage = Math.floor((hadMadeCount / totalCount) * 100)
                            if (percentage < 0) {
                                percentage = 0
                            }
                        } else {
                            percentage = 0
                        }
                        info.percent = percentage
                        that.dingzhiList.push(info)
                    }
                    console.log('this.dingzhiList:',this.dingzhiList)
                    if (list.length < this.pages.size || list.length == 0) {
                        // 数据加载完
                        that.finished_dingzhi = true
                        that.finishedText = '没有更多了'
                        // return
                    }
                    that.searchEnd(res.result.status<=0,list&&list.length>0)
                } else {
                    that.finished_dingzhi = true
                    // return
                }
                this.pages.page++
                this.loading_dingzhi = false
            });
        },
        // 匠人数据
        getTradesmanData() {
            // if(this.unload){
            // 	this.finished_tradesman = true
            //     return
            // }
            console.log('加载匠人', this.loading_tradesman)
            console.log(this.active)
            var that = this
            if (this.active != 1) {
                this.loading_tradesman = false;
                this.finished_tradesman = true
                return
            }
            if (!this.search_value) {
                this.loading_tradesman = false;
                this.finished_tradesman = true
                return
            }
            console.log('getTradesmanData')
            var params = {
                token: this.token,
                key: this.search_value,
                type: 3,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.index.searchData(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.lists;
                    for (var i in list) {
                        that.tradesmanList.push(list[i])
                    }
                    if (list.length < this.pages.size || list.length == 0) {
                        // 数据加载完
                        that.finished_tradesman = true
                        that.finishedText = '没有更多了'
                        // return
                    }
                    that.searchEnd(res.result.status<=0,list&&list.length>0)
                } else {
                    this.finished_tradesman = true
                    // return
                }
                this.pages.page++
                this.loading_tradesman = false
            })
        },
        // 关注 区分app H5
		attentionTadesmanFun(tradesman){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionTadesman(tradesman)
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.attentionTadesman(tradesman)
			}
		},
        // 关注
        attentionTadesman(tradesman) {
            var that = this
            if (tradesman.is_attention == 1) {
                return;
            }
            var params = {
                token: this.token,
                tradesman_id: tradesman.id,
                type: 1
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    that.$toast('关注成功')
                    that.pages.page = 1
                    that.tradesmanList = []
                    that.getTradesmanData()
                } else {
                    that.$toast(res.message)
                }
            })
        },
        // 约看数据
        getYuekanData() {
            var that = this
            if (this.active != 4) {
                this.loading_yuekan = false
                this.finished_yuekan = true
                return
            }
            if (!this.search_value) {
                this.loading_yuekan = false
                this.finished_yuekan = true
                return
            }
            var params = {
                token: this.token,
                key: this.search_value,
                type: 2,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.index.searchData(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.lists;
                    for (var i in list) {
                        that.yuekanList.push(list[i])
                    }
                    if (list.length < this.pages.size || list.length == 0) {
                        // 数据加载完
                        that.finished_yuekan = true
                        that.finishedText = '没有更多了'
                        // return
                    }
                    that.searchEnd(res.result.status<=0,list&&list.length>0)
                } else {
                    that.finished_yuekan = true
                    // return
                }
                this.pages.page++
                this.loading_yuekan = false
            })
        },
        // 匠人详情
        goTradesmanDetail(tradesman) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goBack = false
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: tradesman.id
                    }
                })
            }
		},
        // 商品详情
        goShopDetail(goods) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?goodsId=" + goods.id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/detail" + p
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.goBack = false
                this.$router.push({
                    path: "/shop/detail",
                    query: {
                        goodsId: goods.id,
                    },
                });
            }
        },
        // 定制详情
        goDingzhiDetail(dingzhi) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var url = this.$publicData.clientUrl
                if (this.activeType != 1) {
                    url = url + '/dingzhi/detail?id=' + dingzhi.id
                } else {
                    url = url + '/dingzhi/detail/user?id=' + dingzhi.id
                }
                var params = {
                    'data': {
                        'url': url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goBack = false
                this.$router.push({
                    path: '/dingzhi/detail',
                    query: {
                        id: dingzhi.id
                    }
                })
            }
        },
        // 约看详情
        goYuekanDetail(id) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?id=" + id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/yuekan/detail" + p
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.goBack = false
                this.$router.push({
                    path: '/yuekan/detail',
                    query: {
                        id: id
                    }
                })
            }
            
        },
        // 项目详情
        goItemInfo(id) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?id=" + id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/item/detail" + p
                    }
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    data => {}
                );
            } else {
                this.goBack = false
                this.$router.push({
                    path: "/item/detail",
                    query: {
                        id: id
                    }
                });
            }
        },
        // 去这里
        goSomeWhere(lng, lat, name) {
            this.goBack = false
            console.log('window')
            console.log(window)
            window.location.href = '//uri.amap.com/marker?position=' + lng + ',' + lat + '&name=' + name
        },
        // 去店铺 绑的是匠人店铺
        goShop(id) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?tradesmanId=" + id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/art/detail" + p
                    }
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    data => {}
                );
            } else {
                this.goBack = false
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: id
                    }
                })
            }
        },
        // 关联上键盘搜索，还需要测试ios
        show() {
            this.$refs.input1.blur();
		},
		// js富文本取第一张图片
        imgUrlFun: function(str) {
            var data = "";
            str.replace(/\<img [^>]*src=['"]([^'"]+)[^>]*\>/, function(
                match,
                capture
            ) {
				// console.log('match',match) // 匹配到的字符串
				// console.log('captrue',capture) // 匹配到的子串
                data = capture;
            });
            return data;
        }
    },
}
</script>

<style scoped>
/deep/ .page_item .list {
  padding-left: 0.001rem;
    display: flex;
}
/deep/.van-row--justify-space-between {
    justify-content: flex-start;
}

/deep/.van-tabs__nav {
    display: block;
    white-space: nowrap;
    padding-left: .57rem;
}

/deep/.page .van-tab {
    display: inline-block;
    margin-right: 1.1rem;
    /* color: rgba(51, 51, 51, 1); */
}
/deep/.van-cell .van-field__control {
    color: white;
}
/deep/ input[type="search"]::-webkit-search-cancel-button {
	display: none;
} 
/deep/input::placeholder {
    color: #fff !important;
}
/deep/.page_iteminfo .jiangren .con{
	/* padding-left: 0; */
}
</style>
